import "./assets/style/typography.scss";
import "./assets/style/tables.scss";
// let's initialize with async capabilities
import initialize from "@/initialize";

initialize();
